import React, { useEffect, useState } from "react";
import { Row, Col } from "antd";
import { EventCounter } from "../general/EventCounter";
import { useUser } from "../../context/UserContext";

const Contadores = ({
  filtroZona,
  filtroEstado = ["Open", "InProgress", "FalseAlarm", "Closed"],
  eventos: eventosProp = null,
}) => {
  const apiUrl = process.env.REACT_APP_API_EVENTOS;

  const [eventosAbiertos, setEventosAbiertos] = useState(0);
  const [eventosEjecutando, setEventosEjecutando] = useState(0);
  const [falsaAlarma, setFalsaAlarma] = useState(0);
  const [eventosCerrados, setEventosCerrados] = useState(0);

  const [todosEventos, setTodosEventos] = useState([]);
  const user = useUser();

  // Cuando se pasa eventosProp desde el padre, usarlo directamente
  useEffect(() => {
    if (eventosProp !== null) {
      setTodosEventos(eventosProp);
    }
  }, [eventosProp]);

  const fetchData = async () => {
    let api = apiUrl + "/events";
    try {
      const response = await fetch(api, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${user?.idToken || ""}`,
          "Content-Type": "application/json",
        },
      });

      if (response.ok) {
        const data = await response.json();
        setTodosEventos(data.Items || []);
      } else {
        console.error("Error en la respuesta de la API", response.status);
      }
    } catch (error) {
      console.error("Error al obtener datos de la API", error);
    }
  };

  const calcularContadores = (items) => {
    const eventosFiltrados = items.filter((item) => {
      if (!item.location || !item.location.zone) return false;

      // Si filtroZona es "Todos" no filtra, si no compara
      const cumpleZona =
        filtroZona === "Todos" || item.location.zone === filtroZona;

      // Filtrar por estado
      const cumpleEstado = filtroEstado.includes(item.state);

      return cumpleZona && cumpleEstado;
    });

    const abiertos = eventosFiltrados.filter(
      (item) => item.state === "Open"
    ).length;
    const ejecutando = eventosFiltrados.filter(
      (item) => item.state === "InProgress"
    ).length;
    const falsas = eventosFiltrados.filter(
      (item) => item.state === "FalseAlarm"
    ).length;
    const cerrados = eventosFiltrados.filter(
      (item) => item.state === "Closed"
    ).length;

    setEventosAbiertos(abiertos);
    setEventosEjecutando(ejecutando);
    setFalsaAlarma(falsas);
    setEventosCerrados(cerrados);
  };

  // Fetch propio solo cuando no se reciben eventos del padre
  useEffect(() => {
    if (eventosProp !== null) return;
    fetchData();
    const interval = setInterval(() => { fetchData(); }, 300000);
    return () => clearInterval(interval);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [eventosProp]);

  // 🔥 Nuevo efecto: cuando cambie filtroZona, filtroEstado o los eventos, recalcular
  useEffect(() => {
    if (todosEventos.length > 0) {
      calcularContadores(todosEventos);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [todosEventos, filtroZona, filtroEstado]);

  return (
    <>
      {/* <Row gutter={16}>
      <Col span={6}>
        <Card
          style={{
            minHeight: "130px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Statistic
            title="Eventos Abiertos"
            value={eventosAbiertos}
            valueStyle={{ color: "#faad14", fontSize: "24px" }}
            prefix={<SyncOutlined />}
          />
        </Card>
      </Col>

      <Col span={6}>
        <Card
          style={{
            minHeight: "130px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Statistic
            title="Eventos Ejecutando"
            value={eventosEjecutando}
            valueStyle={{ color: "#1890ff", fontSize: "24px" }}
            prefix={<SyncOutlined spin />}
          />
        </Card>
      </Col>

      <Col span={6}>
        <Card
          style={{
            minHeight: "130px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Statistic
            title="Falsa Alarma"
            value={falsaAlarma}
            valueStyle={{ color: "#ff4d4f", fontSize: "24px" }}
            prefix={<CloseCircleOutlined />}
          />
        </Card>
      </Col>

      <Col span={6}>
        <Card
          style={{
            minHeight: "130px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Statistic
            title="Eventos Cerrados"
            value={eventosCerrados}
            valueStyle={{ color: "#52c41a", fontSize: "24px" }}
            prefix={<CheckCircleOutlined />}
          />
        </Card>
      </Col>
    </Row> */}

      <Row gutter={[16, 16]} className="mb-8">
        <Col xs={24} sm={12} lg={5}>
          <EventCounter
            title="Abiertos"
            count={eventosAbiertos}
            status="abierto"
          />
        </Col>
        <Col xs={24} sm={12} lg={5}>
          <EventCounter
            title="Ejecutando"
            count={eventosEjecutando}
            status="ejecutando"
          />
        </Col>
        <Col xs={24} sm={12} lg={5}>
          <EventCounter
            title="Falsa Alarma"
            count={falsaAlarma}
            status="falsa_alarma"
          />
        </Col>
        <Col xs={24} sm={12} lg={5}>
          <EventCounter
            title="Validados"
            count={eventosCerrados}
            status="validado"
          />
        </Col>
        <Col xs={24} sm={12} lg={4}>
          <EventCounter
            title="Total"
            count={
              eventosAbiertos +
              eventosEjecutando +
              falsaAlarma +
              eventosCerrados
            }
            status="default"
          />
        </Col>
      </Row>
    </>
  );
};

export default Contadores;
